"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xPairs = void 0;
const xPairs = (a, list) => list.map((b) => [a, b]);
exports.xPairs = xPairs;
